import axios from "axios";

const URL_CLIENT = import.meta.env.VITE_AUTH_CLIENT;

export const GetAccompanimentDetailsService = (token, elementId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${URL_CLIENT}/api/admin/v1/accompanyme/${elementId}`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      resolve(response.data.data);
    } catch (error) {
      reject(error);
    }
  });
};